import { Scorecard } from "@components";
import { Card, CardHeader, Typography, Divider } from "@mui/material";
import CustomCardContent from "@pages/PhysicianReview/components/PhysicianReviewContentCards/CustomCardContent";
import { ScorecardObject } from "@providers/hop-ord-server/api";

interface Props {
  scorecardAttachmentsLoading: boolean;
  scorecardsAvailable: boolean;
  scorecardData: ScorecardObject | null;
}
const ScorecardCard = ({
  scorecardAttachmentsLoading,
  scorecardsAvailable,
  scorecardData,
}: Props) => {
  return (
    <Card variant="outlined" data-testid="scorecard-card">
      <CardHeader
        title={<Typography variant="h6">Scorecard</Typography>}
        subheader="Dosimetric criteria displaying plan actuals against goals"
      />
      <Divider />
      <CustomCardContent
        isLoading={scorecardAttachmentsLoading}
        isEmpty={!scorecardsAvailable}
        contentDisplayType="scorecard"
      >
        {scorecardsAvailable && scorecardData && (
          <Scorecard data={scorecardData} />
        )}
      </CustomCardContent>
    </Card>
  );
};
export default ScorecardCard;
